<template>
  <div>
    <div class="content" v-for="(item, index) in dataList" @click="details(item)" :key="index">
      <div>
        <div class="left-tit" >{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import URL from '@/api/api'
export default {
  data() {
    return {
      dataList: [ ],
    };
  },
  mounted() {
    this.getQaList();
  },
  methods: {
      details(item){
        this.$router.push({name: '问卷详情', params: item})
      },
      //获取问卷列表  参与答题的问卷 joinFlag 1  创建的问卷 joinFlag 0
      getQaList() {
        let data={
          openId:localStorage.getItem("openid"),
          joinFlag:'1'
        }
        this.$fetchPost(URL.qaList.url, data).then(res => {
          this.dataList = res.data.data
        })
      }
  },
};
</script>
<style scoped>
.content {
  width: 95%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  line-height: 35px;
  background: #fff;
  border-radius: 5px;
}
.left-tit {
  font-size: 0.35rem;
  font-weight: 600;
  font-family: serif;
}
</style>
